import { tooltipClasses } from '@mui/material/Tooltip';
import { Themes } from '../../style/theme-consts';

const boxShadow = 'var(--popper-shadow)';

export const getStyles = ({ width, height, maxHeight, maxWidth, mode, sx }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: `${
      mode === Themes.LIGHT ? 'var(--tooltip-bg-color-light, #ffffff)' : 'var(--tooltip-bg-color-dark)'
    }`,
    color: `${mode === Themes.LIGHT ? 'var(--tooltip-color-light, rgb(71, 91, 94))' : 'var(--tooltip-color-dark)'}`,
    boxShadow,
    display: 'flex',
    gap: '3px',
    flexWrap: 'wrap',
    fontFamily: 'var(--app-font) Averta, sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    padding: sx?.padding ?? '15px',
    borderRadius: 'var(--popper-radius, 10px)',
    letterSpacing: '0.5px',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    // eslint-disable-next-line no-nested-ternary
    width: `${width ? (typeof width === 'string' ? width : `${width}px`) : 'fit-content'}`,
    // eslint-disable-next-line no-nested-ternary
    maxWidth: maxWidth
      ? typeof maxWidth === 'string'
        ? maxWidth
        : `${maxWidth}px`
      : (width && (typeof width === 'string' ? width : `${width}px`)) || '300px',
    ...(height
      ? {
          height: `${typeof height === 'string' ? height : `${height}px`}`
        }
      : {}),
    ...(maxHeight || height
      ? {
          maxHeight:
            (maxHeight && `${typeof maxHeight === 'string' ? maxHeight : `${maxHeight}px`}`) ||
            (height && `${typeof height === 'string' ? height : `${height}px`}`)
        }
      : {})
  },
  /* Point only: legacy tooltips keep the browser's link colour. */
  [`.point-ds & .${tooltipClasses.tooltip} a`]: {
    color: 'var(--tooltip-link-color)'
  },
  [`& .${tooltipClasses.arrow}`]: {
    /* Same vars as the bubble, or the arrow keeps its legacy colour under a theme. */
    color: `${mode === Themes.LIGHT ? 'var(--tooltip-bg-color-light)' : 'var(--tooltip-bg-color-dark)'}`,
    '&::before': {
      boxShadow: '2px 2px 7px -3px var(--black-300), 0px 0px 4px 0px var(--black-150)'
    }
  }
});

export const POPPER_STYLE = {
  backgroundColor: 'var(--tooltip-bg-color, #ffffff)',
  color: 'var(--tooltip-color, rgb(71, 91, 94))',
  boxShadow,
  padding: '5px',
  borderRadius: 'var(--popper-radius, 10px)',
  zIndex: 10
};
